export default {

	getCompareList: (state) => (listType ) => {

		
		return state[listType]
		// return filter&&filter.isOpen ? true : false
    },
 
    

}